export interface AccessCodeStatus {
  required: boolean;
  verified: boolean;
  code: string | null;
}

export async function checkAccessCodeStatus(): Promise<AccessCodeStatus> {
  const response = await fetch('/api/auth/access-code-status', {
    credentials: 'include',
  });
  if (!response.ok) throw new Error('Failed to check access code status');
  return response.json();
}

export async function verifyAccessCode(code: string): Promise<{ success: boolean; error?: string }> {
  const response = await fetch('/api/auth/verify-code', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ code }),
  });

  const data = await response.json();

  if (!response.ok) {
    return { success: false, error: data.error || 'Invalid code' };
  }

  return { success: true };
}
